import { keyframes, css } from '@emotion/react';
import { scope } from '../../providers/GigerProvider/useTheme.js';
import { SkeletonAnimation } from './types/animation.js';
import { SkeletonBackgroundColor } from './types/backgroundColor.js';
import { SkeletonVariant } from './types/variant.js';

const pulseKeyframes = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.4;
    }
    100% {
        opacity: 1;
    }
`;
const waveKeyframes = keyframes`
    0% {
        transform: translateX(-100%);
    }

    60% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(100%);
    }
`;
const getSkeletonAnimationStyles = animation => {
  switch (animation) {
    case SkeletonAnimation.PULSE:
      return {
        animation: `${pulseKeyframes} 1.5s ease-in-out 0.5s infinite`
      };
    case SkeletonAnimation.WAVE:
      return {
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
          animation: `${waveKeyframes} 1.6s linear 0.5s infinite`,
          background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent)',
          bottom: 0,
          content: '""',
          left: 0,
          position: 'absolute',
          right: 0,
          top: 0,
          transform: 'translateX(-100%)',
          zIndex: 1
        }
      };
    default:
      return {};
  }
};
const getSkeletonBackgroundColorStyles = (backgroundColor, theme) => {
  switch (backgroundColor) {
    case SkeletonBackgroundColor.LIGHT:
      return {
        backgroundColor: theme.palette.gray[100]
      };
    case SkeletonBackgroundColor.DARK:
      return {
        backgroundColor: theme.palette.gray[200]
      };
    default:
      return {};
  }
};
const getSkeletonVariantStyles = (variant, theme) => {
  switch (variant) {
    case SkeletonVariant.TEXT:
      return {
        borderRadius: theme.borderRadius.S,
        '&::before': {
          content: '"\\00a0"'
        }
      };
    case SkeletonVariant.CIRCLE:
      return {
        borderRadius: '50%'
      };
    case SkeletonVariant.RECT:
      return {
        borderRadius: theme.borderRadius.S
      };
    default:
      return {};
  }
};
const getSkeletonStyles = (backgroundColor, variant, animation, height, width) => scope(theme => /*#__PURE__*/css({
  display: 'block',
  ...getSkeletonBackgroundColorStyles(backgroundColor, theme),
  ...getSkeletonVariantStyles(variant, theme),
  ...(animation && getSkeletonAnimationStyles(animation)),
  height: height && `${height}px`,
  width: width && `${width}px`
}, process.env.NODE_ENV === "production" ? "" : ";label:getSkeletonStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export { getSkeletonStyles };
//# sourceMappingURL=SkeletonStyles.js.map
